module.exports = __webpack_public_path__ + "img/navBarLogoVulcan.cac8ca5f.png";